import React from 'react';
import './manageCostObjsPage.scss';
import CostObjsOperations from './comp/costObjsOperations/CostObjsOperationsConnector';
import CostObjEditorContainer from "./comp/costObjEditorContainer/CostObjEditorContainerConnector";

class ManageCostObjsPage extends React.Component {
  componentWillMount() {
    document.title = 'Manage Cost Objects';
  }

  render() {
    return (
      <div className="manage-cost-objs__page react-page">
        <h1>Cost Objects</h1>
        <hr />
        <CostObjEditorContainer />
        <CostObjsOperations />
      </div>
    );
  }
}

export default ManageCostObjsPage;



// WEBPACK FOOTER //
// ./src/components/manageCostObjs/ManageCostObjsPage.js